import { useAxios } from "../../../../hooks/useAxios"
import { PersonasAdapters } from "../adapters/personas.adapters"

// Personas vinculadas a una empresa. Usa la API de Laravel (la misma base que el
// módulo de empresas), por eso se llama con `useAxios` en lugar de `useIntegraWeb`.
const PersonasServices = {

    GET_DISPONIBLES: function () {

        return useAxios({
            method: 'get',
            url: '/integra-web/empresas/personas/disponibles',
            type: 'json',
            adapters: PersonasAdapters.GET_DISPONIBLES
        })
    },

    GET_BUSCAR_PERSONA: function () {

        return useAxios({
            method: 'get',
            url: '/integra-web/empresas/personas/buscar-persona',
            type: 'json',
            adapters: PersonasAdapters.GET_BUSCAR_PERSONA
        })
    },

    POST_SOLICITAR: function () {

        return useAxios({
            method: 'post',
            url: '/integra-web/empresas/personas/solicitar',
            type: 'json',
            adapters: PersonasAdapters.POST_SOLICITAR
        })
    },

    DELETE_PERSONA: function () {

        return useAxios({
            method: 'delete',
            url: '/integra-web/empresas/personas/eliminar',
            type: 'json',
            adapters: PersonasAdapters.DELETE_PERSONA
        })
    },
}

export {
    PersonasServices
}